module.exports = __webpack_public_path__ + "img/6exp.10f28b15.jpg";